import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { EventService } from './event.service';

export const eventServiceModule = angular.module('eventServiceModule', [])
	.factory('eventService', downgradeInjectable(EventService))
	.name;
